import { Component, OnInit, ViewChild, ElementRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from './service/layout.service';
import { AccountService } from '../accounts/service/account.service';
import { NotificationType } from '../accounts/model/NotificationType';
import { CustomErrorHandler } from './service/CustomErrorHandler';
import { Router } from '@angular/router';
import { OwnerUserType } from './model/OwnerUserType';
import { CaseSplitPipe } from '../shared/pipe/CaseSplit.pipe';
import { Subscription } from 'rxjs';

interface PremisesNotificationDetails {
  ownerName: string;
  date: string;
  notificationType: NotificationType;
  notificationTitle: string;
  notificationData: Record<string, any>;
}

@Component({
    templateUrl: './premisesNotificationDetails.component.html',
    styleUrls: ['../revalidation/list.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PremisesNotificationDetailsComponent implements OnInit, OnDestroy {

  NotificationType = NotificationType;
  loading = false;
  searchVisible = true;
  notifications: any[] = [];
  ownerName: string | null = null;
  errorMessage: string | null = null;
  ownerNumber: string | null = null;
  ownerId: string | null = null;

  dateOfNotification: string| null = null;
  notificationType: string|null = null;
  details: PremisesNotificationDetails | null = null;
  premisesNotificationTypeSubscriber$: Subscription | undefined;
  exitToDashboard: boolean = false;
  title!: string;
  
  OwnerUserType = OwnerUserType;
  @ViewChild('ownerNo') ownerNumberRef!: ElementRef;

  constructor(
    public layout: LayoutService,
    public account: AccountService,
    public error: CustomErrorHandler,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loading = true;
    if(!this.details) {
    this.premisesNotificationTypeSubscriber$ = this.account.premisesNotificationType$.subscribe( response => {
      let notification;
      if(response?.ownerId)this.ownerId = response.ownerId;
      if(response?.row !== undefined) notification = response.notifications[response.row];
      if(response?.ownerNumber) this.ownerNumber = response.ownerNumber;
      if(!notification) {
        this.router.navigate(['/notifications']);  
      } else {
        this.account.getPremisesNotificationDetails({ownerId:this.ownerId,notificationItems:notification.recipients}).subscribe(result => {
          this.details = { ownerName: result.notifications[0].data.OwnerName, date: result.notifications[0].time, notificationType: result.notifications[0].type, notificationTitle: result.notifications[0].title, notificationData: result.notifications[0].data };
          this.notifications = result.notifications;
          this.loading = false;
        },
          error => {
            this.loading = false;
            this.errorMessage = 'Unable to fetch the notification details';
            console.log(error);
          });
    }
    });
    }
  }

  search() {}

  setNotificationsDetails(status: boolean, details: {
    owner: { ownerId: string | null; ownerName: string | null; ownerNumber: string | null };
    notifications: any[];
  }): void {
    if(status) {
      this.ownerId = details.owner.ownerId;
      this.ownerName = details.owner.ownerName;
      this.notifications = details.notifications;
    } else {
      this.ownerName = '';
      this.notifications = [];
    }
    
  }

  ngAfterViewInit() {}

  setFocus() {
    if (this.searchVisible) {
      setTimeout(() => {
        this.ownerNumberRef.nativeElement.focus();
      });
    }
  }

  showSearch() {
    this.searchVisible = !this.searchVisible;
  }

  clearSearch() {
    this.ownerNumber = '';
    this.notifications = [];
    this.errorMessage = null;
    this.loading = false;
  }

  getOwnerUserType(type: OwnerUserType): string | undefined {
    return OwnerUserType[type];
  }

  getNotificationType(notificationType: NotificationType) {
  
      const caseSplitPipe = new CaseSplitPipe();
  
      if(notificationType) {
      if (notificationType === NotificationType.RenewalWindowOpeningForPharmacyForCardBACS) {
        return 'Renewal window opening for pharmacy for Card/BACS';
      }
      if (notificationType === NotificationType.PharmacyRenewalDeclarationReminderForDD) {
        return 'Pharmacy renewal declaration reminder for DD';
      }
      if (notificationType === NotificationType.PharmacyRenewalDeclarationMissedForDD) {
        return 'Pharmacy renewal declaration missed for DD';
      }
      if (notificationType === NotificationType.PharmacyRenewalPaymentSubmittedForBACS) {
        return 'Pharmacy renewal payment submitted for BACS';
      }
        return caseSplitPipe.transform(NotificationType[notificationType]);
      }
      return undefined;
    }

  exit() {
    this.exitToDashboard = true;
    this.account.ownerNumber$.next(this.ownerNumber);
    this.router.navigate(['/notifications']);
  }

  ngOnDestroy(){
    this.details = null;
    if(this.exitToDashboard) this.account.ownerNumber$.next(this.ownerNumber);
    else this.account.ownerNumber$.next(null);
    this.premisesNotificationTypeSubscriber$?.unsubscribe();
  }
}
